import React from "react";
import { Container, UserList } from "../components";

const FilmsPage = () => {
    return (
        <Container>
            <UserList />
        </Container>
    );
};

export default FilmsPage;
